import styled from 'styled-components';
import { zIndex } from 'tokens';

// Mobile: Reuse existing button style (exported from parent styles)
export const NewProjectButton = styled.button`
	background: linear-gradient(135deg, #1e90ff 0%, #4169e1 100%);
	color: white;
	border: none;
	padding: 12px 20px;
	font-weight: 600;
	font-size: 15px;
	flex-shrink: 0;
	margin: 20px 16px;
	border-radius: 8px;
	white-space: nowrap;
	box-shadow: 0 4px 12px rgba(30, 144, 255, 0.25), 0 2px 4px rgba(0, 0, 0, 0.3);
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
		opacity: 0;
		transition: opacity 0.2s ease;
	}

	&:hover:not([disabled]) {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(30, 144, 255, 0.35), 0 4px 8px rgba(0, 0, 0, 0.4);
	}

	&:hover:not([disabled])::before {
		opacity: 1;
	}

	&:active:not([disabled]) {
		transform: translateY(-1px);
		box-shadow: 0 3px 10px rgba(30, 144, 255, 0.3), 0 2px 4px rgba(0, 0, 0, 0.3);
	}

	&:disabled {
		opacity: 0.5;
		transform: none;
		box-shadow: none;
	}
`;

// Desktop: Split button container
export const SplitButtonContainer = styled.div`
	display: flex;
	min-width: 0;
	height: 40px;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(30, 144, 255, 0.25), 0 2px 4px rgba(0, 0, 0, 0.3);
	margin: 20px 16px;
	position: relative;
	flex-shrink: 0;
`;

// Desktop: Main button (left part)
export const SplitButtonMain = styled.button`
	flex: 1;
	min-width: 0;
	background: linear-gradient(135deg, #1e90ff 0%, #4169e1 100%);
	color: white;
	border: none;
	padding: 12px 20px;
	font-weight: 600;
	font-size: 15px;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	position: relative;
	overflow: hidden;
	white-space: nowrap;
	border-radius: 8px 0 0 8px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
		opacity: 0;
		transition: opacity 0.2s ease;
	}

	&:hover:not([disabled]) {
		background: linear-gradient(135deg, #3b8ef5 0%, #3b5ee1 100%);
	}

	&:hover:not([disabled])::before {
		opacity: 1;
	}

	&:active:not([disabled]) {
		background: linear-gradient(135deg, #2e7ee5 0%, #2e4ed1 100%);
	}

	&:disabled {
		opacity: 0.5;
	}
`;

// Desktop: Dropdown button (right part)
export const SplitButtonDropdown = styled.button`
	width: 40px;
	background: #3b8ef5;
	border: none;
	border-left: 1px solid rgba(255, 255, 255, 0.2);
	color: white;
	transition: background 0.2s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	border-radius: 0 8px 8px 0;
	overflow: hidden;

	&:hover {
		background: #2e7ee5;
	}

	&:active {
		background: #2563eb;
	}
`;

// Desktop: Dropdown menu
export const DropdownMenu = styled.div`
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	right: 0;
	padding-top: 4px;
	padding-bottom: 4px;
	gap: 4px;
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
	z-index: ${zIndex.panelOverlay};
	overflow: hidden;
`;

// Desktop: Dropdown menu item
export const DropdownMenuItem = styled.button`
	display: flex;
	align-items: center;
	gap: 10px;
	padding-left: 14px;
	padding-right: 12px;
	border-radius: 6px;
	transition: background-color 0.2s ease;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	height: 48px;
	width: 100%;
	border: none;
	background: transparent;
	text-align: left;
	font-weight: 400;

	&:hover:not([disabled]) {
		background-color: ${({ theme }) => theme.gray[200]};
	}

	&:active:not([disabled]) {
		background-color: ${({ theme }) => theme.gray[200]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;
